import autobind from 'autobind-decorator';
import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import { getProblemRecommend, getRecommendSections } from '~/api/oj/home';
import { RouterService } from '~/services/router.service';
import type {
  ContestVO as ContestVO2,
  ProblemRecommendSectionVO,
  ProblemRecommendVO,
} from '~/types/auto/oj';
import { showErrorMsg, showSuccessMsg } from '~/utils/utility';

@Injectable()
export class ProblemRecommendsService {
  public sections = [] as ProblemRecommendSectionVO[];
  public problemsMap = {} as Record<number, ProblemRecommendVO[]>;
  public loadingsMap = {} as Record<number, boolean>;
  public hasError = false;

  @Inject(forwardRef(() => RouterService))
  public routerService!: RouterService;

  init() {
    this.getRecommendSections();
  }

  @autobind
  getRecommendSections() {
    getRecommendSections()
      .then((res) => {
        this.sections = res;
        this.hasError = false;
      })
      .catch((err) => {
        showErrorMsg(err);
        this.hasError = true;
      });
  }

  @autobind
  getProblemRecommend(id: number) {
    this.loadingsMap[id] = true;
    getProblemRecommend(id)
      .then((res) => {
        if (res.length > 0) {
          this.problemsMap[id] = res;
        }
      })
      .catch((err) => {
        showErrorMsg(err);
      })
      .finally(() => {
        this.loadingsMap[id] = false;
      });
  }
}
